const turnOn = false;
export const logConsole = (message, useConsole) => {
    // || useConsole
    if(turnOn) {
        console.log(message);
    }
}
